export default "__VITE_ASSET__6241716a__"